module.exports = __webpack_public_path__ + "img/pdf.2913ef51.png";